<template>
  <div>
    <div class="content_left">
      <h3 class="ltitle">
        <p>{{ $t('message.myProfile') }}</p>
        <span class="left" @click="changeInfoStatus()"
          ><i class="icon-edit"></i>{{ $t('message.edit') }}</span
        >
      </h3>
      <p class="information">{{ $t('message.aboutMe') }}</p>
      <div class="detail_information">
        <div class="tip">
          <span class="left">{{ $t('user.FullName') }}</span>
          <span class="right">{{ user.lastName }} {{ user.firstName }}</span>
        </div>
        <div class="tip">
          <span class="left">{{ $t('user.Email') }}</span>
          <span class="right">{{ user.email }}</span>
        </div>
        <div class="tip">
          <span class="left">{{ $t('user.Title') }}</span>
          <span class="right">{{ user.title }}</span>
        </div>
        <div class="tip">
          <span class="left">{{ $t('user.Company') }}</span>
          <span class="right">{{ user.company }}</span>
        </div>
      </div>
    </div>
    <updateUser
      :updateInfoStatus="updateInfoStatus"
      @close2="close2"
      @updateUser="updateUser"
    ></updateUser>
  </div>
</template>

<script>
import updateUser from './updateUser'
export default {
  name: 'userInfo',
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  components: { updateUser },
  data() {
    return {
      updateInfoStatus: false
    }
  },
  methods: {
    changeInfoStatus() {
      this.updateInfoStatus = true
    },
    close2() {
      this.updateInfoStatus = false
    },
    updateUser() {
      this.$emit('updateUser')
    }
  }
}
</script>

<style lang="scss" scoped>
.content_left {
  width: 480px;
  height: 378px;
  background: $white;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 48px 45px 50px;
  box-sizing: border-box;
  .ltitle {
    height: 24px;
    font-size: 20px;
    font-family: NexaBold;
    color: rgba(31, 37, 62, 1);
    line-height: 24px;
    @include flex-space-between;
    & > span {
      color: rgba(255, 97, 35, 1);
      font-size: 12px;
      cursor: pointer;
      font-family: Roboto-Regular;
      @include flex-align-center;
      .icon-edit {
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }
  .information {
    height: 19px;
    font-size: 16px;
    font-family: NexaLight;
    color: rgba(31, 37, 62, 0.6);
    line-height: 19px;
    margin: 24px 0 32px;
  }
  .detail_information {
    .tip {
      height: 17px;
      margin-bottom: 29px;
      @include flex-start;
      .left {
        width: 103px;
        font-size: 14px;
        font-family: Lato-Regular;
        font-weight: 400;
        color: rgba(31, 37, 62, 0.6);
      }
      .right {
        font-size: 16px;
        font-family: Lato-Bold;
        font-weight: bold;
        color: rgba(31, 37, 62, 1);
      }
    }
  }
}
@media screen and (max-width: 1313px) {
  .content_left {
    width: 100%;
    height: auto;
    margin-bottom: 30px;
    .detail_information {
      display: flex;
      flex-wrap: wrap;
      .tip {
        width: 50%;
      }
    }
  }
}
@media screen and (max-width: 1110px) {
  .content_left {
    height: 378px;
    .detail_information {
      display: block;
      .tip {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settings/userInfo.vue